import React, { Fragment, Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import Footer from "./Common/Footer";
import Home from "./Component/Home/Home";
import NotFoundPage from "./Common/404";
import Header from "./Common/Header";
import {
  AboutUsPage,
  ContactUsPage,
  TermsConditionsPage,
  PrivacyPolicyPage,
} from "./Component/StaticPages/StaticPages";

function App() {
  return (
    <BrowserRouter>
      <Suspense
      // fallback={<MainLoader />}
      >
        <Routes>
          <Route
            path="/"
            exact
            element={
              <Fragment>
                <Header/>
                <Home />
                <Footer />
              </Fragment>
            }
          />
          <Route
            path="/about-us"
            element={
              <Fragment>
                <Header />
                <AboutUsPage />
                <Footer />
              </Fragment>
            }
          />
          <Route
            path="/contact-us"
            element={
              <Fragment>
                <Header />
                <ContactUsPage />
                <Footer />
              </Fragment>
            }
          />
          <Route
            path="/terms-conditions"
            element={
              <Fragment>
                <Header />
                <TermsConditionsPage />
                <Footer />
              </Fragment>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <Fragment>
                <Header />
                <PrivacyPolicyPage />
                <Footer />
              </Fragment>
            }
          />

           {/* <Route path="/404" element={<NotFoundPage/>} /> */}
           {/* <Route path="*" element={<Navigate to='/404' replace />} /> */}
           <Route path="*" element={<Navigate to='/' replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;


